import React from 'react';
import { FieldDefinition } from './FieldRenderer';

interface DynamicCheckboxFieldProps {
  field: FieldDefinition;
  value: any;
  onChange: (fieldKey: string, value: any) => void;
  error?: string;
  disabled?: boolean;
  isArabic: boolean;
}

const DynamicCheckboxField: React.FC<DynamicCheckboxFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  isArabic
}) => {
  const label = isArabic ? field.label_ar || field.label : field.label;

  const handleChange = (optionValue: string, checked: boolean) => {
    const currentValue = Array.isArray(value) ? value : [];

    if (checked) {
      const newValue = [...currentValue, optionValue];
      onChange(field.key, newValue);
    } else {
      const newValue = currentValue.filter((v: string) => v !== optionValue);
      onChange(field.key, newValue);
    }
  };

  const isChecked = (optionValue: string) => {
    return Array.isArray(value) && value.includes(optionValue);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="space-y-2">
        {field.options?.map((option, index) => (
          <label key={index} className="flex items-center">
            <input
              type="checkbox"
              checked={isChecked(option.value)}
              onChange={(e) => handleChange(option.value, e.target.checked)}
              disabled={disabled}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <span className={`ml-2 text-sm text-gray-700 ${isArabic ? 'text-right' : 'text-left'}`}>
              {isArabic ? option.label_ar || option.label : option.label}
            </span>
          </label>
        ))}
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default DynamicCheckboxField;